import React from "react";

import { Column, Row } from "@rui/Stack";

import { LeftContentContainer } from "./styles";

export interface UpsellModuleInnerContentProps {
  children: React.ReactNode;
  img?: React.ReactNode;
}

const UpsellModuleInnerContent = ({
  children,
  img,
}: UpsellModuleInnerContentProps) => (
  <Row spacing={2} justifyContent="space-between" zIndex={1}>
    <LeftContentContainer spacing={1}>
      <Column spacing={1}>{children}</Column>
    </LeftContentContainer>
    {img}
  </Row>
);

export default UpsellModuleInnerContent;
